import Content from "../Content";
import CrossCommSession from "../CrossCommSession";
import {ViewInfoViews} from "../ViewInfo";
import {RequestActionsConstant} from "./RequestActionsConstant";
import RequestBase from "./RequestBase";

export default class ContentPageRequest extends RequestBase {
    public constructor(
        public readonly crossCommSession: CrossCommSession,
        public readonly teamsToken: string,
        public readonly action: RequestActionsConstant,
        public readonly requestPageNumber: number,
        public readonly searchText: string
    ) {
        super();
        this.action = action;
    }
}
